var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSheild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.61224 7.56224L7.32328 9.10169L10.3877 6.34456M8 1.5L2 3.74132V6.46594C2 9.99203 4.3715 13.1675 8 14.5C11.6285 13.1675 14 9.99203 14 6.46594V3.74132L8 1.5Z",
    stroke: "#333333",
    strokeWidth: 1.11429,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheild);
export default __webpack_public_path__ + "static/media/sheild.72dc6f1a77cca8f1a5ff22c1777b3aa2.svg";
export { ForwardRef as ReactComponent };